<template>
  <v-layout>
    <NavbarPublic />

    <v-flex xs12 text-xs-center class="mt-5">
      <v-card class="pt-5 pb-5 ml-5 mr-5 mt-5">
        <h1>404</h1>
        <p>
          A keresett oldal nem található!
        </p>

        <v-btn large color="info" @click="$router.push({ name: 'main' })">
          Főoldal
          <v-icon right dark>home</v-icon>
        </v-btn>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import NavbarPublic from '@/views/NavbarPublic';

export default {
  components: {
    NavbarPublic
  },
  data: () => ({}),

  method: () => ({})
};
</script>

<style lang="scss" scoped></style>
